var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 7.88235H1V4.82353C1 3.97886 1.69645 3.29412 2.55556 3.29412H5.66667M1.77778 7.88235V12.4706C1.77778 13.3153 2.47422 14 3.33333 14H12.6667C13.5258 14 14.2222 13.3153 14.2222 12.4706V7.88235M1.77778 7.88235H6.44444M5.66667 3.29412V2.52941C5.66667 1.68474 6.36311 1 7.22222 1H8.77778C9.63691 1 10.3333 1.68474 10.3333 2.52941V3.29412M5.66667 3.29412H10.3333M14.2222 7.88235H15V4.82353C15 3.97886 14.3036 3.29412 13.4444 3.29412H10.3333M14.2222 7.88235H9.55556M6.44444 7.88235V6.35294H9.55556V7.88235M6.44444 7.88235V9.41176H9.55556V7.88235",
    stroke: "#33363F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/Jobs.4a16c85a484d93663ea246db17b6b1b3.svg";
export { ForwardRef as ReactComponent };